import React from 'react'
import { Dialog } from 'primereact/dialog';

export const DialogPreviewPdf = (props) => {

    const {

        showPreview, pdfPreviewUrl, handleOpenPreview, setPdfPreviewUrl, setShowPreview } = props;

    return (
        <Dialog
            header="Previsualización de PDF"
            visible={showPreview}
            style={{ width: '60vw', maxWidth: '700px' }}
            modal
            dismissableMask
            onHide={() => setShowPreview(false)}
            headerStyle={{
                backgroundColor: '#0d3b59',
                color: 'white',
                fontWeight: 'bold',
            }}
            pt={{
                header: { style: { backgroundColor: '#0d3b59', color: 'white' } },
                headerIcon: { style: { color: 'white' } },
            }}
        >
            {pdfPreviewUrl && (
                <iframe
                    src={pdfPreviewUrl}
                    title="PDF Preview"
                    width="100%"
                    height="600px"
                    style={{ border: "none" }}
                />
            )}
        </Dialog>

    )
}
